import Toolbar from "@imminently/decisively-ui/Toolbar";
import { FloatingVerticalDivider } from "@udecode/plate";
import type { PropsWithChildren } from "react";
import { HistoryToolbar, RichTextToollbar } from "./basicToolbar";

/**
 * A rich text only toolbar that has the basic controls
 */
export const FixedRichTextToolbar = ({ children, ...props }: any & PropsWithChildren) => {
  return (
    <Toolbar className="border-b border-border" {...props}>
      <HistoryToolbar />
      <FloatingVerticalDivider />
      <RichTextToollbar />
      {children}
    </Toolbar>
  );
};
